import { app } from '../../app';
import { Controller } from './sp-editable-image.controller';

app.component('spEditableImage', {
    bindings: {
        imageMaxSize: '<',
        resettable: '<',
        onSave: '&',
        onReset: '&',
    },
    controller: Controller,
    templateUrl: require('./sp-editable-image.html'),
});



// WEBPACK FOOTER //
// ./src/portal/components/sp-editable-image/sp-editable-image.component.js